module.exports = __webpack_public_path__ + "static/four_explain_en.e012111b.png";